var React = require('react');

function Briefcase (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z","key":1})]);
}

Briefcase.defaultProps = {"height":"24px","viewBox":"0 0 24 24","width":"24px"};

module.exports = Briefcase;

Briefcase.default = Briefcase;
